/*
 * Copyright (C) 2024 S&P Global.
 * All Rights Reserved
 */
export function interpolate(baseString: string, values: Record<string, any>): string {
  return baseString.replace(/\${(.*?)}/g, (match: string, p1: string) => {
    const keys = p1.split(".").reduce((acc: (string | number)[], key: string) => {
      const arrayMatch = key.match(/(\w+)\[(\d+)\]/);
      if (arrayMatch) {
        acc.push(arrayMatch[1], Number(arrayMatch[2]));
      } else {
        acc.push(key);
      }
      return acc;
    }, []);

    let value: any = values;
    for (const key of keys) {
      if (value && key in value) {
        value = value[key];
      } else {
        return ""; // Return empty string if key is not found
      }
    }
    return value;
  });
}
